import { HashMap1a0ld5kgwhmhv as HashMap } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashMap.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { Exceptiondt2hlxn7j7vw as Exception } from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  stackTraceToString2670q6lbhdojj as stackTraceToString,
  printStackTrace18lnx7a39cni as printStackTrace,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/throwableExtensions.mjs';
import {
  _Dimension___get_value__impl__urhqzrblez9tu1bx9v as _Dimension___get_value__impl__urhqzr,
  timesx4ey3un7ihw1 as times,
  divkhq3vjih9fcw as div,
  MinWidthmy5c27t0vx62 as MinWidth,
  MinHeight1d4eo0z72v5cz as MinHeight,
  MaxWidth3w3zqziye9hut as MaxWidth,
  MaxHeight3e6pmlm3xkuk4 as MaxHeight,
  MinAspectRatio2013cocyd0aan as MinAspectRatio,
  MaxAspectRatio1wpxrnyd9eji1 as MaxAspectRatio,
  Updatefnuihmjsla6n as Update,
  Pointer1u5ideccnki5y as Pointer,
  Hover1ygztk1sofk4b as Hover,
  DisplayMode1pn688e4egpke as DisplayMode,
  Or3j9abhvhjviwp as Or,
  And1jik66wmc7j6f as And,
  Not1uanfh2ezdtkv as Not,
  get_entries3nqgftw5r4i02 as get_entries,
  Dimensions32ju1l7z4mh as Dimension,
  times2ukvaf6yk96p2 as times_0,
} from '../models/data.mjs';
import {
  listOf1jh22dvmctj1r as listOf,
  listOfNotNull2woi2boe01ub4 as listOfNotNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import {
  joinToString1cxrrlmo0chqs as joinToString,
  asSequence2phdjljfh9jhx as asSequence,
  plus310ted5e4i90h as plus,
  getOrNull1go7ef9ldk0df as getOrNull,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { DurationUnit_SECONDS_getInstance162tnxlnf2fpv as DurationUnit_SECONDS_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/time/DurationUnitJs.mjs';
import {
  Duration__toDouble_impl_a56y2b33i3iqk8qiaoq as Duration__toDouble_impl_a56y2b,
  Companion_getInstance2jahap30xtp3t as Companion_getInstance,
  toDuration7gy6v749ektt as toDuration,
  Duration5ynfiptaqcrg as Duration,
  Duration__plus_impl_yu9v8fuwslfu377uhg as Duration__plus_impl_yu9v8f,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { numberToInt1ygmcfwhs2fkq as numberToInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/numberConversion.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import {
  HoverSemantic_getInstance3081oh8o0tv4w as HoverSemantic_getInstance,
  FocusSemantic_getInstance1u11pdt9aclin as FocusSemantic_getInstance,
  DownSemantic_getInstancejvxqp4oqx0tj as DownSemantic_getInstance,
  DisabledSemantic_getInstancet3o5kouryhbf as DisabledSemantic_getInstance,
  PrintSemantic_getInstance20sw3wh3j3vdl as PrintSemantic_getInstance,
  SelectedSemantic_getInstance3adr60xrkcq3z as SelectedSemantic_getInstance,
  UnselectedSemantic_getInstance1xc7cb2k39ftl as UnselectedSemantic_getInstance,
} from '../models/Theme.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { asSequence2jzw5xbq99nu9 as asSequence_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import {
  mapsbvh18eqox7a as map,
  flatMapgxtanzi5fvh9 as flatMap,
  joinToStringooja5rkatz3u as joinToString_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/sequences/_Sequences.mjs';
import { roundToInt1ue8x8yshtznx as roundToInt } from '../../../../../kotlin-kotlin-stdlib/kotlin/math/math.mjs';
import {
  LogLevel_WARN_getInstance3t76hodk0ofiq as LogLevel_WARN_getInstance,
  Log1znm0y8m419dj as Log,
} from '../debugger.mjs';
import { listOfvhqybd2zx248 as listOf_0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { trimIndent1qytc1wvt8suh as trimIndent } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Indent.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  Monotonic_instancewn07e60bp6rj as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs31ikzp5dku7pk as ValueTimeMark__elapsedNow_impl_eonqvs,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/TimeSource.mjs';
import { equals2au1ep9vhcato as equals } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import {
  FadingColor3d6ef6zcqmlhk as FadingColor,
  RadialGradient3ic79yys0k1fp as RadialGradient,
  LinearGradient2qftccjwl6uey as LinearGradient,
  Color17ck47lkedxoy as Color,
} from '../models/Paint.mjs';
import {
  Companion_getInstance3o2pcl1yhcf6p as Companion_getInstance_0,
  _Angle___get_turns__impl__atdtw5psbuz3qdt26e as _Angle___get_turns__impl__atdtw5,
  _Angle___init__impl__g23q1m3btd89vsaotdr as _Angle___init__impl__g23q1m,
} from '../models/Angle.mjs';
import {
  get_px8ok5q0jdway2 as get_px,
  toRawCornerRadius19avvfrnu4o3m as toRawCornerRadius,
  Companion_getInstance2s2nvbwu43fem as Companion_getInstance_1,
} from '../models/data.commonHtml.mjs';
import { maxOfnpw4mt1rg0hl as maxOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/_ComparisonsJs.mjs';
import { CornerShape_Continuous_getInstancexm3mpluosqyq as CornerShape_Continuous_getInstance } from '../models/CornerShape.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import { numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/rangeTo.mjs';
import { isLetterOrDigit2kuxd9e198haf as isLetterOrDigit } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/charJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var WarnOnceClass;
function WarnOnce() {
  if (WarnOnceClass === VOID) {
    class $ {
      constructor(log) {
        this.log_1 = log;
        this.sources_1 = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
        this.reported_1 = HashSet().new_kotlin_collections_HashSet_ovxcsm_k$();
      }
      declare_rfmc70_k$(theme) {
        var tmp0 = this.sources_1;
        // Inline function 'kotlin.collections.set' call
        var key = theme.id_1;
        tmp0.put_4fpzoq_k$(key, theme);
      }
      checkAndReport_bltzb7_k$(theme) {
        var prior = this.sources_1.get_wei43m_k$(theme.id_1);
        if (!(prior == null) && !(prior === theme) && !prior.structurallyEquals_bpxpie_k$(theme) && this.reported_1.add_utx5q5_k$(theme.id_1)) {
          this.log_1.warn_e3mr9o_k$(["Theme id collision on '" + theme.id_1 + "': two different Themes share this id, so " + "both render with the CSS generated for the first one and the second one's differences - including any semanticOverrides - are dropped. Give the themes distinct ids (Theme.copy and the semantic helpers chain ids for you; Theme.customize and the Theme constructor do not)."]);
        }
      }
    }
    initMetadataForClass($, 'WarnOnce');
    WarnOnceClass = $;
  }
  return WarnOnceClass;
}
var CountWarningsClass;
function CountWarnings() {
  if (CountWarningsClass === VOID) {
    class $ {
      constructor(log) {
        this.log_1 = log;
        this.sources_1 = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
      }
      declare_rfmc70_k$(theme) {
        var tmp0 = this.sources_1;
        var tmp2 = theme.id_1;
        // Inline function 'kotlin.collections.set' call
        var value = to(theme, 0);
        tmp0.put_4fpzoq_k$(tmp2, value);
      }
      checkAndReport_bltzb7_k$(theme) {
        var tmp0_elvis_lhs = this.sources_1.get_wei43m_k$(theme.id_1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return Unit_instance;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var _destruct__k2r9zo = tmp;
        var prior = _destruct__k2r9zo.component1_7eebsc_k$();
        var count = _destruct__k2r9zo.component2_7eebsb_k$();
        if (!(prior === theme) && !prior.structurallyEquals_bpxpie_k$(theme)) {
          if (count === 0) {
            this.log_1.warn_e3mr9o_k$(["Theme id collision on '" + theme.id_1 + "': two different Themes share this id, so " + "both render with the CSS generated for the first one and the second one's differences - including any semanticOverrides - are dropped. Give the themes distinct ids (Theme.copy and the semantic helpers chain ids for you; Theme.customize and the Theme constructor do not)."]);
          } else {
            this.log_1.info_59mt0k_k$(["'" + theme.id_1 + "' additional collision found (count = " + count + ')']);
          }
        }
        var tmp0 = this.sources_1;
        var tmp2 = theme.id_1;
        // Inline function 'kotlin.collections.set' call
        var value = to(prior, count + 1 | 0);
        tmp0.put_4fpzoq_k$(tmp2, value);
      }
    }
    initMetadataForClass($, 'CountWarnings');
    CountWarningsClass = $;
  }
  return CountWarningsClass;
}
var StacktraceOnceClass;
function StacktraceOnce() {
  if (StacktraceOnceClass === VOID) {
    class $ {
      constructor(log) {
        this.log_1 = log;
        this.sources_1 = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
        this.reported_1 = HashSet().new_kotlin_collections_HashSet_ovxcsm_k$();
      }
      declare_rfmc70_k$(theme) {
        var tmp0 = this.sources_1;
        var tmp2 = theme.id_1;
        // Inline function 'kotlin.collections.set' call
        var value = to(theme, Exception().new_kotlin_Exception_hsqbop_k$('Theme first declared here'));
        tmp0.put_4fpzoq_k$(tmp2, value);
      }
      checkAndReport_bltzb7_k$(theme) {
        var tmp0_elvis_lhs = this.sources_1.get_wei43m_k$(theme.id_1);
        var tmp;
        if (tmp0_elvis_lhs == null) {
          return Unit_instance;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        var _destruct__k2r9zo = tmp;
        var prior = _destruct__k2r9zo.component1_7eebsc_k$();
        var declaredAt = _destruct__k2r9zo.component2_7eebsb_k$();
        if (!(prior === theme) && !prior.structurallyEquals_bpxpie_k$(theme) && this.reported_1.add_utx5q5_k$(theme.id_1)) {
          this.log_1.warn_e3mr9o_k$(["Theme id collision on '" + theme.id_1 + "': two different Themes share this id, so " + "both render with the CSS generated for the first one and the second one's differences - including any semanticOverrides - are dropped. Give the themes distinct ids (Theme.copy and the semantic helpers chain ids for you; Theme.customize and the Theme constructor do not).\n" + ('First declared at:\n' + stackTraceToString(declaredAt))]);
        }
      }
    }
    initMetadataForClass($, 'StacktraceOnce');
    StacktraceOnceClass = $;
  }
  return StacktraceOnceClass;
}
function toBoxShadow($this, $receiver) {
  if (_Dimension___get_value__impl__urhqzr($receiver).get_roughPx_o6ay0o_k$() === 0.0)
    return 'none';
  return joinToString(listOf(['0px ' + _Dimension___get_value__impl__urhqzr(times($receiver, 3.0 / 2)).toString() + ' ' + _Dimension___get_value__impl__urhqzr(div($receiver, 2)).toString() + ' -' + _Dimension___get_value__impl__urhqzr($receiver).toString() + ' rgba(0, 0, 0, 0.2)', '0px ' + _Dimension___get_value__impl__urhqzr($receiver).toString() + ' ' + _Dimension___get_value__impl__urhqzr($receiver).toString() + ' 0px rgba(0, 0, 0, 0.14)', '0px ' + _Dimension___get_value__impl__urhqzr(div($receiver, 2)).toString() + ' ' + _Dimension___get_value__impl__urhqzr(times($receiver, 5.0 / 2)).toString() + ' 0px rgba(0, 0, 0, 0.12)']), ', ');
}
function toCss($this, $receiver) {
  return Duration__toDouble_impl_a56y2b($receiver, DurationUnit_SECONDS_getInstance()).toString() + 's';
}
function joinGradientStops($this, stops) {
  return joinToString(stops, VOID, VOID, VOID, VOID, VOID, KiteUiCss$joinGradientStops$lambda);
}
function _get_classes__of2uz9($this, $receiver) {
  return 't-' + $receiver.id_1;
}
function _get_classSelector__lhiabq($this, $receiver) {
  return '.' + _get_classes__of2uz9($this, $receiver);
}
function render($this, $receiver) {
  var tmp;
  if ($receiver instanceof Not()) {
    tmp = '(not ' + render($this, $receiver.query_1) + ')';
  } else {
    if ($receiver instanceof And()) {
      tmp = joinToString($receiver.queries_1, ' and ', '(', ')', VOID, VOID, (it) => render($this, it));
    } else {
      if ($receiver instanceof Or()) {
        tmp = joinToString($receiver.queries_1, ' or ', '(', ')', VOID, VOID, (it) => render($this, it));
      } else {
        if ($receiver instanceof DisplayMode()) {
          var tmp_0;
          switch ($receiver.value_1.ordinal_1) {
            case 0:
              tmp_0 = '(display-mode: browser)';
              break;
            case 1:
              tmp_0 = '(display-mode: fullscreen)';
              break;
            case 2:
              tmp_0 = '(display-mode: minimal-ui)';
              break;
            case 3:
              tmp_0 = '(display-mode: picture-in-picture)';
              break;
            case 4:
              tmp_0 = '(display-mode: standalone)';
              break;
            case 5:
              tmp_0 = '(display-mode: window-controls-overlay)';
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }
          tmp = tmp_0;
        } else {
          if ($receiver instanceof Hover()) {
            var tmp_1;
            switch ($receiver.value_1.ordinal_1) {
              case 0:
                tmp_1 = '(hover: none)';
                break;
              case 1:
                tmp_1 = '(hover: hover)';
                break;
              default:
                noWhenBranchMatchedException();
                break;
            }
            tmp = tmp_1;
          } else {
            if ($receiver instanceof Pointer()) {
              var tmp_2;
              switch ($receiver.value_1.ordinal_1) {
                case 0:
                  tmp_2 = '(pointer: none)';
                  break;
                case 1:
                  tmp_2 = '(pointer: coarse)';
                  break;
                case 2:
                  tmp_2 = '(pointer: fine)';
                  break;
                default:
                  noWhenBranchMatchedException();
                  break;
              }
              tmp = tmp_2;
            } else {
              if ($receiver instanceof Update()) {
                var tmp_3;
                switch ($receiver.value_1.ordinal_1) {
                  case 0:
                    tmp_3 = '(update: none)';
                    break;
                  case 1:
                    tmp_3 = '(update: slow)';
                    break;
                  case 2:
                    tmp_3 = '(update: fast)';
                    break;
                  default:
                    noWhenBranchMatchedException();
                    break;
                }
                tmp = tmp_3;
              } else {
                if ($receiver instanceof MaxAspectRatio()) {
                  tmp = '(max-aspect-ratio: ' + $receiver.ratio_1 + ')';
                } else {
                  if ($receiver instanceof MinAspectRatio()) {
                    tmp = '(min-aspect-ratio: ' + $receiver.ratio_1 + ')';
                  } else {
                    if ($receiver instanceof MaxHeight()) {
                      tmp = '(max-height: ' + _Dimension___get_value__impl__urhqzr($receiver.dimension_1).toString() + ')';
                    } else {
                      if ($receiver instanceof MaxWidth()) {
                        tmp = '(max-width: ' + _Dimension___get_value__impl__urhqzr($receiver.dimension_1).toString() + ')';
                      } else {
                        if ($receiver instanceof MinHeight()) {
                          tmp = '(min-height: ' + _Dimension___get_value__impl__urhqzr($receiver.dimension_1).toString() + ')';
                        } else {
                          if ($receiver instanceof MinWidth()) {
                            tmp = '(min-width: ' + _Dimension___get_value__impl__urhqzr($receiver.dimension_1).toString() + ')';
                          } else {
                            noWhenBranchMatchedException();
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  return tmp;
}
function KiteUiCss$lambda(it) {
  // Inline function 'kotlin.text.lowercase' call
  // Inline function 'kotlin.js.asDynamic' call
  return it.name_1.toLowerCase();
}
function transition$toCssTransform(_this__u8e3s4) {
  // Inline function 'kotlin.collections.mutableListOf' call
  var parts = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  if (!(_this__u8e3s4.translationX_1 === 0.0) || !(_this__u8e3s4.translationY_1 === 0.0)) {
    parts.add_utx5q5_k$('translate(' + numberToInt(_this__u8e3s4.translationX_1 * 100) + '%, ' + numberToInt(_this__u8e3s4.translationY_1 * 100) + '%)');
  }
  if (!(_this__u8e3s4.scaleX_1 === 1.0) || !(_this__u8e3s4.scaleY_1 === 1.0)) {
    parts.add_utx5q5_k$('scale(' + _this__u8e3s4.scaleX_1 + ', ' + _this__u8e3s4.scaleY_1 + ')');
  }
  if (!(_this__u8e3s4.rotation_1 === 0.0)) {
    parts.add_utx5q5_k$('rotate(' + _this__u8e3s4.rotation_1 + 'deg)');
  }
  if (!(_this__u8e3s4.rotationX_1 === 0.0)) {
    parts.add_utx5q5_k$('rotateX(' + _this__u8e3s4.rotationX_1 + 'deg)');
  }
  if (!(_this__u8e3s4.rotationY_1 === 0.0)) {
    parts.add_utx5q5_k$('rotateY(' + _this__u8e3s4.rotationY_1 + 'deg)');
  }
  if (!(_this__u8e3s4.translationZ_1 === 0.0)) {
    parts.add_utx5q5_k$('translateZ(' + _this__u8e3s4.translationZ_1 + 'px)');
  }
  return parts.isEmpty_y1axqb_k$() ? 'none' : joinToString(parts, ' ');
}
function KiteUiCss$joinGradientStops$lambda(it) {
  return it.color_1.toWeb_1tsvdl_k$() + ' ' + it.ratio_1 * 100 + '%';
}
function themeInteractive$sub($theme, this$0, cs, subthemeGen, asSelectors, diff) {
  diff = diff === VOID ? $theme : diff;
  var tmp;
  if (subthemeGen == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    tmp = $theme.get_6y9l0r_k$(subthemeGen);
  }
  var tmp1_elvis_lhs = tmp;
  var subtheme = tmp1_elvis_lhs == null ? $theme.withoutBack_1 : tmp1_elvis_lhs;
  if (!$theme.equals(subtheme.theme_1)) {
    // Inline function 'kotlin.collections.flatMap' call
    // Inline function 'kotlin.collections.flatMapTo' call
    var destination = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
    var _iterator__ex2g4s = asSelectors.iterator_jk1svi_k$();
    while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
      var element = _iterator__ex2g4s.next_20eer_k$();
      var list = listOf([element + ' ' + cs, element + cs]);
      addAll(destination, list);
    }
    this$0.theme$default_1dahcl_k$(subtheme.theme_1, diff, destination, subtheme.drawBackground_1);
  }
  var hov = subtheme.get_6y9l0r_k$(HoverSemantic_getInstance());
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_0 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s_0 = asSelectors.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
    var element_0 = _iterator__ex2g4s_0.next_20eer_k$();
    var list_0 = listOf(['.clickable:hover' + element_0 + ' ' + cs, '.clickable:hover' + element_0 + cs]);
    addAll(destination_0, list_0);
  }
  this$0.theme_e3nnmq_k$(hov.theme_1, diff, destination_0, hov.drawBackground_1, '(hover : hover)');
  var foc = subtheme.get_6y9l0r_k$(FocusSemantic_getInstance());
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_1 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s_1 = asSelectors.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_1.hasNext_bitz1p_k$()) {
    var element_1 = _iterator__ex2g4s_1.next_20eer_k$();
    var list_1 = listOf(['.clickable:focus-visible' + element_1 + ' ' + cs, '.clickable:focus-visible' + element_1 + cs, 'input:focus' + element_1 + cs, 'textarea:focus' + element_1 + cs, 'select:focus' + element_1 + cs, '.hasNoBackField:focus-within' + element_1 + cs]);
    addAll(destination_1, list_1);
  }
  this$0.theme$default_1dahcl_k$(foc.theme_1, diff, destination_1, foc.drawBackground_1);
  var dwn = subtheme.get_6y9l0r_k$(DownSemantic_getInstance());
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_2 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s_2 = asSelectors.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_2.hasNext_bitz1p_k$()) {
    var element_2 = _iterator__ex2g4s_2.next_20eer_k$();
    var list_2 = listOf(['.clickable:active' + element_2 + ' ' + cs, '.clickable:active' + element_2 + cs]);
    addAll(destination_2, list_2);
  }
  this$0.theme$default_1dahcl_k$(dwn.theme_1, diff, destination_2, dwn.drawBackground_1);
  var dis = subtheme.get_6y9l0r_k$(DisabledSemantic_getInstance());
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_3 = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
  var _iterator__ex2g4s_3 = asSelectors.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_3.hasNext_bitz1p_k$()) {
    var element_3 = _iterator__ex2g4s_3.next_20eer_k$();
    var list_3 = listOf(['.clickable:disabled' + element_3 + ' ' + cs, '.clickable:disabled' + element_3 + cs]);
    addAll(destination_3, list_3);
  }
  this$0.theme$default_1dahcl_k$(dis.theme_1, diff, destination_3, dis.drawBackground_1);
  var print = subtheme.get_6y9l0r_k$(PrintSemantic_getInstance());
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_4 = ArrayList().new_kotlin_collections_ArrayList_tdd6ob_k$(collectionSizeOrDefault(asSelectors, 10));
  var _iterator__ex2g4s_4 = asSelectors.iterator_jk1svi_k$();
  while (_iterator__ex2g4s_4.hasNext_bitz1p_k$()) {
    var item = _iterator__ex2g4s_4.next_20eer_k$();
    var tmp$ret$19 = item + cs + cs;
    destination_4.add_utx5q5_k$(tmp$ret$19);
  }
  this$0.theme_e3nnmq_k$(print.theme_1, diff, destination_4, print.drawBackground_1, 'print');
}
function theme$sel($asSelectors, plus) {
  var tmp = asSequence($asSelectors);
  return joinToString_0(flatMap(tmp, (it) => {
    var tmp = asSequence_0(plus);
    return map(tmp, (p) => '' + it + p);
  }), ', ');
}
function theme$addToCss(this$0, $mediaQuery, selector, key, value) {
  this$0.dynamicCss_1.add_nb48up_k$(selector, key, value, $mediaQuery);
}
function KiteUiCss$rowCollapsingToColumn$lambda(it) {
  return roundToInt(_Dimension___get_value__impl__urhqzr(it.value_1).get_roughPx_o6ay0o_k$()).toString();
}
var KiteUiCssClass;
function KiteUiCss() {
  if (KiteUiCssClass === VOID) {
    class $ {
      constructor(dynamicCss, log) {
        log = log === VOID ? Log('KiteUiCss', LogLevel_WARN_getInstance()) : log;
        this.dynamicCss_1 = dynamicCss;
        this.log_1 = log;
        try {
          this.dynamicCss_1.rule$default_4ip9wm_k$('@media print {\n    .do-not-print{\n        display: none !important;\n    }\n    .scroll-vertical {\n        overflow: hidden auto;\n    }\n    body > div {\n        height: unset;\n        max-width: 100vw;\n    }\n\n    body {\n        height: unset;\n        max-height: unset;\n        max-width: 100vw;\n        overflow: visible;\n    }\n    .kiteui-col > * {\n        flex-grow: 0 !important;\n        flex-shrink: 0 !important;\n        flex-basis: unset !important;\n    }\n}');
        } catch ($p) {
          if ($p instanceof Exception()) {
            var e = $p;
            printStackTrace(Exception().new_kotlin_Exception_9qyiel_k$('Failed to add print ruleset', e));
          } else {
            throw $p;
          }
        }
        this.dynamicCss_1.rule$default_4ip9wm_k$(':root { --corner-shape-scale: 1; }');
        try {
          this.dynamicCss_1.rule$default_4ip9wm_k$('@supports (corner-shape: squircle) { :root:root { --corner-shape-scale: 3; } }');
        } catch ($p_0) {
          if ($p_0 instanceof Exception()) {
            var _unused_var__etf5q3 = $p_0;
          } else {
            throw $p_0;
          }
        }
        this.dynamicCss_1.rule$default_4ip9wm_k$(' /*noinspection ALL*/@media {\n .kui {\n     margin: 0;\n     padding: 0;\n     border: 0;\n     font-size: 100%;\n     font: inherit;\n     vertical-align: baseline;\n }\n \n p.kui, h1.kui, h2.kui, h3.kui, h4.kui, h5.kui, h6.kui, .subtext {\n     white-space: pre-wrap;\n }\n \n p.kui li.kui {\n     margin-inline-start: 1em;\n }\n p.kui a.kui {\n     text-decoration: revert;\n     color: revert;\n }\n p.kui a.kui:visited {\n     color: revert;\n }\n\n /* HTML5 display-role reset for older browsers */\n article.kui, aside.kui, details.kui, figcaption.kui, figure.kui, footer.kui, header.kui, hgroup.kui, menu.kui, nav.kui, section.kui {\n     display: block;\n }\n\n .kui-basic-html-content b, .kui-basic-html-content strong { font-weight: bold; }\n .kui-basic-html-content i, .kui-basic-html-content em { font-style: italic; }\n .kui-basic-html-content u { text-decoration: underline; }\n .kui-basic-html-content s, .kui-basic-html-content strike { text-decoration: line-through; }\n\n body {\n     line-height: 1;\n }\n\n ol.kui, ul.kui {\n     list-style: none;\n }\n\n blockquote.kui, q.kui {\n     quotes: none;\n }\n\n blockquote.kui:before, blockquote.kui:after, q.kui:before, q.kui:after {\n     content: \'\';\n     content: none;\n }\n\n table.kui {\n     border-collapse: collapse;\n     border-spacing: 0;\n }\n\n .kui.icon {\n     color: var(--icon-color, black);\n }\n\n .kui.padded:not(.swapImage) {\n     padding: var(--padding, 0px);\n }\n\n input.kui[type="number"] {\n     appearance: textfield;\n }\n\n input.kui::-webkit-outer-spin-button, input::-webkit-inner-spin-button {\n     appearance: none;\n }\n\n progress.kui::-moz-progress-bar {\n     height: 100%;\n     background-color: currentcolor;\n     border-radius: 1rem;\n }\n\n progress.kui::-webkit-progress-bar {\n     border-radius: 100px;\n }\n\n progress.kui::-webkit-progress-value {\n     height: 100%;\n     background-color: currentcolor;\n     border-radius: 1rem;\n }\n\n /* The linear bar\'s thinness cap, scoped away from the circular ring.\n    Unscoped, this capped every <progress> at 4px tall - and being !important it beat the\n    inline height sizeConstraints writes, so a ring asked for 4rem rendered as a 64x4\n    sliver. min-height appeared to fix it only because min-height wins over max-height. */\n progress.kui:not(.kiteui-circular-progress) {\n     max-height: 0.25rem !important;\n }\n\n progress.kui {\n     background: none;\n     border: medium;\n     border-radius: 1rem;\n     padding: 0px !important;\n     /* WebKit/Safari (and older Blink) require the prefixed reset before\n        ::-webkit-progress-bar/::-webkit-progress-value custom styling applies;\n        without it they render the native bar and ignore the currentcolor fill.\n        Firefox uses ::-moz-progress-bar and honors the unprefixed property. */\n     -webkit-appearance: none;\n     -moz-appearance: none;\n     appearance: none;\n }\n \n \n \n.kui.progress-ring {\n   width: 100%;\n   justify-content: space-around;\n }\n \n .kui.progress-ring-svg {\n     display: block;\n     margin: 10px auto;\n }\n\n\n @media (pointer: coarse) and (hover: none) {\n     .touchscreenOnly {\n         visibility: visible;\n     }\n }\n \n * {\n     gap: var(--spacing, 0);\n }       \n\n .kui.touchscreenOnly {\n }\n .kui.disableContextMenu {\n     -webkit-user-select: none !important;  \n     -webkit-touch-callout: none !important;  \n }\n\n .kui.viewPager > :not(.recyclerViewCap) {\n     width: var(--pager-width, 0rem);\n     height: var(--pager-height, 0rem);\n     scroll-snap-align: center;\n     scroll-snap-stop: always;\n }\n\n .kui.viewPager {\n     scroll-snap-type: x mandatory;\n }\n\n .kui.hideScrollbar {\n     scrollbar-width: none;\n }\n .kui.hideScrollbar::-webkit-scrollbar {\n     display: none;\n }\n\n .kui.suppress-overflow-anchors > * {\n     overflow-anchor: none;\n }\n\n .kui.notransition, .kui.notransition * {\n     transition: none !important;\n }\n\n .kui.animatingShowHide {\n     overflow: hidden;\n }\n\n .kui {\n     box-sizing: border-box;\n     line-height: unset;\n     --parentPadding: 0px;\n     scrollbar-color: rgb(153, 153, 153) rgba(0, 0, 0, 0);\n     scrollbar-width: thin;\n     scrollbar-gutter: auto;\n     flex-shrink: 0;\n     max-width: calc(100%);\n     max-height: calc(100%);\n     min-height: 0px;\n     min-width: 0px;\n     padding: 0px;\n     transition-timing-function: linear;\n     transition-delay: 0s;\n     transition-property: color, background-image, background-color, border-color, outline-color, outline-width, box-shadow, border-radius, opacity, backdrop-filter, transform;\n }\n \n .kui.transition {\n     overflow: hidden;\n }\n\n .kui[hidden] {\n     display: none !important;\n }\n\n @keyframes spin {\n     0% {\n         transform: rotate(0deg);\n     }\n     100% {\n         transform: rotate(360deg);\n     }\n }\n\n .ptr-indicator {\n     height: 0;\n     overflow: hidden;\n     display: flex;\n     justify-content: center;\n     align-items: center;\n     pointer-events: none;\n     z-index: 10000;\n     color: currentcolor;\n }\n\n .ptr-spinner {\n     width: 28px;\n     height: 28px;\n     border: 3px solid currentcolor;\n     border-top-color: transparent;\n     border-radius: 50%;\n     animation: spin 0.8s linear infinite;\n     box-sizing: border-box;\n }\n\n .ptr-icon-circle {\n     width: 48px;\n     height: 48px;\n     border-radius: 50%;\n     background: var(--nearest-background-color, color-mix(in srgb, currentcolor 12%, transparent));\n     box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n     display: flex;\n     justify-content: center;\n     align-items: center;\n     transition: transform 0.15s ease;\n }\n\n .ptr-arrow {\n     width: 28px;\n     height: 28px;\n }\n\n @keyframes flickerAnimation {\n     0% {\n         opacity: 1;\n     }\n     50% {\n         opacity: 0.5;\n     }\n     100% {\n         opacity: 1;\n     }\n }\n\n .kui::-webkit-scrollbar-corner {\n     background: none;\n }\n\n .kui::-webkit-scrollbar-thumb {\n     background: color-mix(in srgb, currentcolor 20%, transparent);\n     border-radius: 4px;\n }\n\n .kui::-webkit-scrollbar {\n     background: none;\n }\n\n .kui.scroll-horizontal {\n     overflow: auto hidden;\n }\n\n .kui.scroll-horizontal  * {\n     max-width: unset;\n }\n\n .kui.scroll-vertical {\n     overflow: hidden auto;\n }\n\n .kui.scroll-vertical  * {\n     max-height: unset;\n }\n .kui.has-set-height * {\n     max-height: 100%;\n }\n\n iframe#webpack-dev-server-client-overlay {\n     display: none !important;\n }\n\n .kui.kiteui-separator {\n     background-color: var(--separator-color, currentcolor);\n     min-width: 1px;\n     min-height: 1px;\n }\n\n .kui::placeholder {\n     color: currentcolor;\n     opacity: 0.3;\n }\n\n .kiteui-label.kiteui-label {\n     display: flex;\n     flex-direction: column;\n     align-items: stretch;\n }\n\n .crowd {\n     padding: 0px !important;\n }\n\n :checked.radio::after {\n     opacity: 1;\n     transform: none;\n }\n\n .radio::after {\n     position: absolute;\n     border-radius: 999px;\n     content: "";\n     display: block;\n     width: 50%;\n     height: 50%;\n     top: 25%;\n     left: 25%;\n     background-color: currentcolor;\n     opacity: 0.4;\n     transform: scale(0);\n     transition-property: opacity, transform;\n     transition-timing-function: linear;\n     transition-duration: var(--transition-duration, 0.25s);\n }\n\n .radio.radio.radio {\n     appearance: none;\n     width: 25px !important;\n     height: 25px !important;\n     position: relative;\n     border-radius: 999px !important;\n     padding: 0px !important;\n     border-width: 0.1rem;\n     border-style: solid;\n     outline: none;\n     border-color: var(--icon-color, currentcolor);\n }\n\n :checked.checkbox::after {\n     opacity: 1;\n     transform: rotate(-45deg);\n }\n\n .checkbox::after {\n     position: absolute;\n     content: "";\n     display: block;\n     width: 50%;\n     height: 20%;\n     top: 25%;\n     left: 20%;\n     border-color: currentcolor;\n     border-left-style: solid;\n     border-left-width: 0.2rem;\n     border-bottom-width: 0.2rem;\n     border-bottom-style: solid;\n     opacity: 0.4;\n     transform: rotate(-45deg) scale(0);\n     transition-property: opacity, transform;\n     transition-timing-function: linear;\n     transition-duration: var(--transition-duration, 0.25s);\n }\n\n .checkbox:checked {\n     opacity: 1;\n }\n\n .checkbox.checkbox.checkbox {\n     appearance: none;\n     width: 25px !important;\n     height: 25px !important;\n     position: relative;\n     padding: 0px !important;\n     border-width: 0.1rem;\n     border-style: solid;\n     border-color: var(--icon-color, currentcolor);\n     border-radius: 20%;\n     outline: none;\n     opacity: 0.75;\n }\n\n .switch:checked::before {\n     left: calc(1.4rem);\n }\n\n .switch::before {\n     position: absolute;\n     content: "";\n     left: calc(-0.1rem);\n     top: calc(-0.1rem);\n     display: block;\n     height: 1.6rem;\n     width: 1.6rem;\n     max-width: unset;\n     max-height: unset;\n     cursor: pointer;\n     border: 1px solid rgba(100, 116, 139, 0.527);\n     border-radius: 9999px !important;\n     background-color: rgb(255, 255, 255);\n     box-shadow: rgba(100, 116, 139, 0.327) 0px 3px 10px;\n     transition: 0.3s;\n }\n\n .switch:checked {\n     background-color: #20a020 !important;\n }\n\n .switch {\n     position: relative;\n     overflow: visible;\n     padding: 0px !important;\n     height: 1.5rem !important;\n     width: 3rem !important;\n     cursor: pointer;\n     appearance: none;\n     border-radius: 9999px !important;\n     background-color: color-mix(in srgb, currentcolor 20%, transparent) !important;\n     background-image: none !important;\n     transition: 0.3s;\n }\n\n .clickable {\n     cursor: pointer;\n }\n\n button.kui {\n     position: relative;\n }\n\n button.kui.working::after {\n     opacity: 0.5 !important;\n     content: "";\n     pointer-events: none;\n     position: absolute;\n     top: calc(50% - 15px);\n     left: calc(50% - 15px);\n     width: 20px !important;\n     height: 20px !important;\n     background: none !important;\n     box-shadow: none !important;\n     border-style: solid !important;\n     border-color: currentcolor currentcolor currentcolor transparent !important;\n     border-width: 6px !important;\n     border-radius: 50% !important;\n     transition: 0.3s;\n     animation: 2s linear infinite spin !important;\n }\n \n .popover {\n     transition-property: color, background-image, background-color, border-color, outline-color, outline-width, box-shadow, border-radius, opacity, backdrop-filter;\n }\n\n img.kui {\n     overflow: hidden;\n }\n \n .optimized > * {\n     display: block;\n }\n .weakFill {\n     width: 100%;\n     height: 100%;\n }\n\n .spinner {\n     display: block;\n     width: 32px !important;\n     height: 32px !important;\n     opacity: 0.5;\n     background: none !important;\n     box-shadow: none !important;\n     border-style: solid !important;\n     border-color: currentcolor currentcolor currentcolor transparent !important;\n     border-width: 5px !important;\n     border-radius: 50% !important;\n     animation: 2s linear infinite spin !important;\n }\n\n input.kui:focus:not(.transition), select.kui:focus:not(.transition), textarea.kui:focus:not(.transition) {\n     outline: none;\n }\n\n /* Containers focused only to move a screen reader (announceAsNewScreen) must not draw\n    the browser\'s focus ring around the whole screen. */\n .kui[tabindex="-1"]:focus {\n     outline: none;\n }\n\n button.kui, input.kui, textarea.kui, select.kui {\n     background: none;\n     border-width: 0px;\n     outline-width: 0px;\n     font: unset;\n     color: unset;\n     text-align: start;\n }\n\n /* Safari (WebKit) renders a native-appearance <select> as an OS control and ignores\n    CSS padding entirely. Resetting appearance makes it a styleable box so our themed\n    --padding is honored. Removing the native appearance also drops the native chevron,\n    so we redraw one with two gradients in currentColor (gradients honor currentColor,\n    unlike background-image SVGs) so it always matches the themed text color. */\n select.kui {\n     -webkit-appearance: none;\n     -moz-appearance: none;\n     appearance: none;\n     background-image:\n         linear-gradient(45deg, transparent 50%, currentColor 50%),\n         linear-gradient(135deg, currentColor 50%, transparent 50%);\n     background-position:\n         right 0.9em top 55%,\n         right 0.5em top 55%;\n     background-size: 0.4em 0.4em, 0.4em 0.4em;\n     background-repeat: no-repeat;\n }\n\n /* Reserve room for the redrawn chevron on top of the theme\'s padding so long\n    values never run under the arrow. */\n select.kui.padded {\n     padding-right: calc(var(--padding, 0px) + 1.4em);\n }\n\n a.kui:visited {\n     color: unset;\n }\n\n a.kui {\n     text-decoration: none;\n     color: unset;\n     display: block;\n }\n\n body > div.kui {\n     height: 100%;\n     max-width: 100vw;\n }\n\n body {\n     height: 100svh;\n     max-height: 100svh;\n     max-width: 100vw;\n     overflow: hidden;\n }\n\n .noInteraction.noInteraction {\n     pointer-events: none;\n }\n .noInteraction > * {\n     pointer-events: auto;\n }\n\n video.scaleType-NoScale {\n     object-fit: none;\n }\n\n video.scaleType-Stretch {\n     object-fit: fill;\n }\n\n video.scaleType-Crop {\n     object-fit: cover;\n }\n\n video.scaleType-Fit {\n     object-fit: contain;\n }\n\n img.scaleType-NoScale {\n     object-fit: none;\n }\n\n img.scaleType-Stretch {\n     object-fit: fill;\n }\n\n img.scaleType-Crop {\n     object-fit: cover;\n }\n\n img.scaleType-Fit {\n     object-fit: contain;\n }\n \n .clickable.draggable {\n     cursor: default;\n }\n .draggable {\n     cursor: grab;\n }\n\n .swapImage > img {\n     object-fit: contain;\n     transition-duration: var(--transition-duration, 0.25s);\n   position: absolute;\n     width: 100%;\n   height: 100%;\n }\n .swapImage {\n   position: relative;\n }\n\n .swapImage.loading.useLoading::before {\n     display: block;\n     content: " ";\n     width: 32px !important;\n     height: 32px !important;\n     position: absolute;\n     left: calc(50% - 32px);\n     top: calc(50% - 32px);\n     opacity: 0.5 !important;\n     background: none !important;\n     box-shadow: none !important;\n     border-style: solid !important;\n     border-color: currentcolor currentcolor currentcolor transparent !important;\n     border-width: 5px !important;\n     border-radius: 50% !important;\n     animation: 2s linear infinite spin !important;\n }\n\n .swapImage, .icon {\n     overflow: hidden;\n     line-height: 0px;\n     display: block;\n }\n .icon {\n     border-radius: 0px !important;\n }\n .icon.icon > svg {\n     display: block;\n     max-width: 100%;\n     max-height: 100%;\n }\n \n .textarea-container {\n   /* easy way to plop the elements on top of each other and have them both sized based on the tallest one\'s height */\n   display: grid;\n   position: relative;\n   overflow-y: scroll;\n }\n .textarea-container::after {\n   /* Note the weird space! Needed to preventy jumpy behavior */\n   content: attr(data-replicated-value) " ";\n\n   /* This is how textarea text behaves */\n   white-space: pre-wrap;\n\n   /* Hidden from view, clicks, and screen readers */\n   visibility: hidden;\n   \n   padding: 2px;\n }\n .textarea-container > textarea {\n   /* You could leave this, but after a user resizes, then it ruins the auto sizing */\n   resize: none;\n   position: absolute;\n   left: 0;\n   right: 0;\n   top: 0;\n   bottom: 0;\n }\n .textarea-container > textarea,\n .textarea-container::after {\n   /* Identical styling required!! */\n   font: inherit;\n\n   /* Place on top of each other */\n   grid-area: 1 / 1 / 2 / 2;\n }\n\n .kiteui-space {\n     display: block;\n     min-height: calc(var(--space-multiplier, 1.0) * var(--spacing, 0px));\n     min-width: calc(var(--space-multiplier, 1.0) * var(--spacing, 0px));\n }\n\n .kui:hover.visibleOnParentHover {\n     visibility: visible;\n }\n\n .kui:hover > .visibleOnParentHover {\n     visibility: visible;\n }\n\n .visibleOnParentHover {\n     visibility: hidden;\n     width: auto;\n     height: auto;\n     max-width: unset;\n     max-height: unset;\n }\n\n }');
        var _iterator__ex2g4s = plus(get_entries(), listOf_0(null)).iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var h = _iterator__ex2g4s.next_20eer_k$();
          var _iterator__ex2g4s_0 = plus(get_entries(), listOf_0(null)).iterator_jk1svi_k$();
          while (_iterator__ex2g4s_0.hasNext_bitz1p_k$()) {
            var v = _iterator__ex2g4s_0.next_20eer_k$();
            var tmp = toString(h);
            var tmp_0 = toString(v);
            var tmp_1 = listOfNotNull([h, v]);
            this.dynamicCss_1.rule$default_4ip9wm_k$(trimIndent('\n                    .kui.snapTo-' + tmp + '-' + tmp_0 + ' > :not(:first-child) {\n                        scroll-snap-align: ' + joinToString(tmp_1, ' ', VOID, VOID, VOID, VOID, KiteUiCss$lambda) + '\n                    }\n                '));
          }
        }
        try {
          this.dynamicCss_1.rule$default_4ip9wm_k$('progress.kui::-webkit-progress-value {\n                    height: 100%;\n                    background-color: currentColor;\n                    border-radius: 1rem;\n                }');
        } catch ($p_1) {
          if ($p_1 instanceof Error) {
            var e_0 = $p_1;
          } else {
            throw $p_1;
          }
        }
        try {
          this.dynamicCss_1.rule$default_4ip9wm_k$('progress.kui::-webkit-progress-bar {\n                    border-radius: 100px;\n                    background: var(--nearest-background-color);\n                    padding: 1px;\n                }');
        } catch ($p_2) {
          if ($p_2 instanceof Error) {
            var e_1 = $p_2;
          } else {
            throw $p_2;
          }
        }
        try {
          this.dynamicCss_1.rule$default_4ip9wm_k$('progress.kui::-moz-progress-bar {\n                    height: 100%;\n                    background-color: currentColor;\n                    border-radius: 1rem;\n                }');
        } catch ($p_3) {
          if ($p_3 instanceof Error) {
            var e_2 = $p_3;
          } else {
            throw $p_3;
          }
        }
        try {
          this.dynamicCss_1.rule$default_4ip9wm_k$('progress.kui.kiteui-circular-progress {\n                    --kiteui-progress: 0;\n                    --kiteui-progress-width: 3px;\n                    appearance: none;\n                    -webkit-appearance: none;\n                    border: none;\n                    aspect-ratio: 1 / 1;\n                    border-radius: 50%;\n                    background: conic-gradient(\n                        currentcolor calc(var(--kiteui-progress) * 360deg),\n                        var(--nearest-background-color, transparent) 0\n                    );\n                    -webkit-mask: radial-gradient(\n                        closest-side,\n                        transparent calc(100% - var(--kiteui-progress-width)),\n                        #000 calc(100% - var(--kiteui-progress-width))\n                    );\n                    mask: radial-gradient(\n                        closest-side,\n                        transparent calc(100% - var(--kiteui-progress-width)),\n                        #000 calc(100% - var(--kiteui-progress-width))\n                    );\n                }');
        } catch ($p_4) {
          if ($p_4 instanceof Error) {
            var e_3 = $p_4;
          } else {
            throw $p_4;
          }
        }
        try {
          this.dynamicCss_1.rule$default_4ip9wm_k$('progress.kui.kiteui-circular-progress::-webkit-progress-bar {\n                    background: transparent;\n                    border-radius: 0;\n                    padding: 0;\n                }');
        } catch ($p_5) {
          if ($p_5 instanceof Error) {
            var e_4 = $p_5;
          } else {
            throw $p_5;
          }
        }
        try {
          this.dynamicCss_1.rule$default_4ip9wm_k$('progress.kui.kiteui-circular-progress::-webkit-progress-value {\n                    background: transparent;\n                    background-color: transparent;\n                }');
        } catch ($p_6) {
          if ($p_6 instanceof Error) {
            var e_5 = $p_6;
          } else {
            throw $p_6;
          }
        }
        try {
          this.dynamicCss_1.rule$default_4ip9wm_k$('progress.kui.kiteui-circular-progress::-moz-progress-bar {\n                    background: transparent;\n                    background-color: transparent;\n                }');
        } catch ($p_7) {
          if ($p_7 instanceof Error) {
            var e_6 = $p_7;
          } else {
            throw $p_7;
          }
        }
        try {
          this.dynamicCss_1.rule$default_4ip9wm_k$('input.kui::-webkit-outer-spin-button, input.kui::-webkit-inner-spin-button {\n                    -webkit-appearance: none;\n                }');
        } catch ($p_8) {
          if ($p_8 instanceof Error) {
            var e_7 = $p_8;
          } else {
            throw $p_8;
          }
        }
        try {
          this.dynamicCss_1.rule$default_4ip9wm_k$('input.kui[type=number] {\n                    -moz-appearance: textfield\n                }');
        } catch ($p_9) {
          if ($p_9 instanceof Error) {
            var e_8 = $p_9;
          } else {
            throw $p_9;
          }
        }
        this.transitionHandled_1 = HashSet().new_kotlin_collections_HashSet_ovxcsm_k$();
        var tmp_2 = this;
        // Inline function 'kotlin.time.Companion.seconds' call
        Companion_getInstance();
        tmp_2.cssGenTotal_1 = toDuration(0, DurationUnit_SECONDS_getInstance());
        this.themeInteractiveHandled_1 = HashSet().new_kotlin_collections_HashSet_ovxcsm_k$();
        var tmp_3 = this;
        var tmp0_safe_receiver = this.log_1;
        var tmp1_subject = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.get_level_ium7h7_k$();
        switch (tmp1_subject == null ? -1 : tmp1_subject.ordinal_1) {
          case 3:
            tmp_3.collisions_1 = new (StacktraceOnce())(this.log_1);
            break;
          case 2:
            tmp_3.collisions_1 = new (CountWarnings())(this.log_1);
            break;
          case 1:
            tmp_3.collisions_1 = new (WarnOnce())(this.log_1);
            break;
          default:
            tmp_3.collisions_1 = null;
            break;
        }
        this.rowCollapsingToColumnHandled_1 = HashSet().new_kotlin_collections_HashSet_ovxcsm_k$();
        this.querySetHandled_1 = HashMap().new_kotlin_collections_HashMap_2a5kxx_k$();
      }
      transition_pc86d7_k$(transition) {
        if (!this.transitionHandled_1.add_utx5q5_k$(transition.name_1))
          return 'transition-' + transition.name_1;
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_0 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
        this_0.append_22ad7x_k$('@keyframes transition-' + transition.name_1 + '-enter { from { ');
        this_0.append_22ad7x_k$('transform: ' + transition$toCssTransform(transition.entryTransform_1) + '; ');
        if (transition.fade_1) {
          this_0.append_22ad7x_k$('opacity: 0; ');
        }
        this_0.append_22ad7x_k$('} to { ');
        this_0.append_22ad7x_k$('transform: none; ');
        if (transition.fade_1) {
          this_0.append_22ad7x_k$('opacity: 1; ');
        }
        this_0.append_22ad7x_k$('} }');
        var tmp$ret$0 = this_0.toString();
        this.dynamicCss_1.rule_nw06my_k$(tmp$ret$0, 0);
        // Inline function 'kotlin.text.buildString' call
        // Inline function 'kotlin.apply' call
        var this_1 = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
        this_1.append_22ad7x_k$('@keyframes transition-' + transition.name_1 + '-exit { from { ');
        this_1.append_22ad7x_k$('transform: none; ');
        if (transition.fade_1) {
          this_1.append_22ad7x_k$('opacity: 1; ');
        }
        this_1.append_22ad7x_k$('} to { ');
        this_1.append_22ad7x_k$('transform: ' + transition$toCssTransform(transition.exitTransform_1) + '; ');
        if (transition.fade_1) {
          this_1.append_22ad7x_k$('opacity: 0; ');
        }
        this_1.append_22ad7x_k$('} }');
        var tmp$ret$3 = this_1.toString();
        this.dynamicCss_1.rule_nw06my_k$(tmp$ret$3, 0);
        return 'transition-' + transition.name_1;
      }
      themeInteractive_19n8xp_k$(theme) {
        if (!this.themeInteractiveHandled_1.add_utx5q5_k$(theme.id_1)) {
          var tmp0_safe_receiver = this.collisions_1;
          if (tmp0_safe_receiver == null)
            null;
          else {
            tmp0_safe_receiver.checkAndReport_bltzb7_k$(theme);
          }
          return _get_classes__of2uz9(this, theme);
        } else {
          var tmp1_safe_receiver = this.collisions_1;
          if (tmp1_safe_receiver == null)
            null;
          else {
            tmp1_safe_receiver.declare_rfmc70_k$(theme);
          }
        }
        // Inline function 'kotlin.time.measureTime' call
        // Inline function 'kotlin.time.measureTime' call
        var mark = Monotonic_instance.markNow_ns2ype_k$();
        var tmp0_safe_receiver_0 = theme.derivedFrom_1;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          this.themeInteractive_19n8xp_k$(tmp0_safe_receiver_0);
        }
        this.theme$default_1dahcl_k$(theme);
        var cs = _get_classSelector__lhiabq(this, theme);
        themeInteractive$sub(theme, this, cs, null, listOf_0(''));
        var tmp1_subthemeGen = SelectedSemantic_getInstance();
        var tmp2_diff = theme.get_6y9l0r_k$(UnselectedSemantic_getInstance()).theme_1;
        var tmp3_asSelectors = listOf_0('.checked.checkResponsive');
        themeInteractive$sub(theme, this, cs, tmp1_subthemeGen, tmp3_asSelectors, tmp2_diff);
        themeInteractive$sub(theme, this, cs, UnselectedSemantic_getInstance(), listOf_0('.checkResponsive'));
        var tmp$ret$0 = ValueTimeMark__elapsedNow_impl_eonqvs(mark);
        // Inline function 'kotlin.also' call
        var this_0 = new (Duration())(tmp$ret$0);
        var it = this_0.rawValue_1;
        this.cssGenTotal_1 = Duration__plus_impl_yu9v8f(this.cssGenTotal_1, it);
        this_0.rawValue_1;
        this.dynamicCss_1.flush_shahbo_k$();
        return _get_classes__of2uz9(this, theme);
      }
      theme_e3nnmq_k$(theme, diff, asSelectors, includeMaybeTransition, mediaQuery) {
        var classes = _get_classes__of2uz9(this, theme);
        var directSel = theme$sel(asSelectors, ['.kui']);
        var backSel = includeMaybeTransition ? theme$sel(asSelectors, ['.kui.clickable']) : theme$sel(asSelectors, ['.kui.transition']);
        var paddedSel = includeMaybeTransition ? theme$sel(asSelectors, ['.kui.clickable']) : theme$sel(asSelectors, ['.kui.padded']);
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_0 = theme.background_1;
        var tmp;
        var tmp_0;
        if (diff == null) {
          tmp_0 = null;
        } else {
          tmp_0 = diff.background_1;
        }
        if (!equals(tmp_0, this_0)) {
          tmp = this_0;
        } else {
          tmp = null;
        }
        var tmp0_safe_receiver = tmp;
        if (tmp0_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          var tmp_1 = diff == null ? null : diff.background_1;
          if (tmp_1 instanceof FadingColor()) {
            theme$addToCss(this, mediaQuery, backSel, 'animation', 'none');
          }
          if (tmp0_safe_receiver instanceof Color()) {
            theme$addToCss(this, mediaQuery, backSel, 'background-color', tmp0_safe_receiver.toWeb_1tsvdl_k$());
            theme$addToCss(this, mediaQuery, backSel, 'background-image', 'none');
          } else {
            if (tmp0_safe_receiver instanceof FadingColor()) {
              this.dynamicCss_1.rule$default_4ip9wm_k$(trimIndent('\n                        @keyframes ' + theme.id_1 + '-flickerAnimation {\n                        0% {\n                            background-color: ' + tmp0_safe_receiver.base_1.toWeb_1tsvdl_k$() + ';\n                        }\n                        50% {\n                            background-color: ' + tmp0_safe_receiver.alternate_1.toWeb_1tsvdl_k$() + ';\n                        }\n                        100% {\n                            background-color: ' + tmp0_safe_receiver.base_1.toWeb_1tsvdl_k$() + ';\n                        }\n                    }\n                    '));
              theme$addToCss(this, mediaQuery, backSel, 'animation', '2s infinite ' + theme.id_1 + '-flickerAnimation');
              theme$addToCss(this, mediaQuery, backSel, 'background-color', tmp0_safe_receiver.base_1.toWeb_1tsvdl_k$());
              theme$addToCss(this, mediaQuery, backSel, 'background-image', 'none');
            } else {
              if (tmp0_safe_receiver instanceof LinearGradient()) {
                theme$addToCss(this, mediaQuery, backSel, 'background-color', tmp0_safe_receiver.closestColor_akwbqu_k$().toWeb_1tsvdl_k$());
                var tmp0 = tmp0_safe_receiver.angle_1;
                // Inline function 'com.lightningkite.kiteui.models.Angle.plus' call
                var other = Companion_getInstance_0().quarterTurn_1;
                var tmp$ret$7 = _Angle___init__impl__g23q1m(_Angle___get_turns__impl__atdtw5(tmp0) + _Angle___get_turns__impl__atdtw5(other));
                theme$addToCss(this, mediaQuery, backSel, 'background-image', 'linear-gradient(' + _Angle___get_turns__impl__atdtw5(tmp$ret$7) + 'turn, ' + joinGradientStops(this, tmp0_safe_receiver.stops_1) + ')');
                theme$addToCss(this, mediaQuery, backSel, 'background-attachment', tmp0_safe_receiver.screenStatic_1 ? 'fixed' : 'unset');
              } else {
                if (tmp0_safe_receiver instanceof RadialGradient()) {
                  theme$addToCss(this, mediaQuery, backSel, 'background-color', tmp0_safe_receiver.closestColor_akwbqu_k$().toWeb_1tsvdl_k$());
                  theme$addToCss(this, mediaQuery, backSel, 'background-image', 'radial-gradient(circle at center, ' + joinGradientStops(this, tmp0_safe_receiver.stops_1) + ')');
                  theme$addToCss(this, mediaQuery, backSel, 'background-attachment', tmp0_safe_receiver.screenStatic_1 ? 'fixed' : 'unset');
                } else {
                  noWhenBranchMatchedException();
                }
              }
            }
          }
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_1 = new (Dimension())(theme.outlineWidth_1);
        var tmp_2;
        var tmp_3;
        if (diff == null) {
          tmp_3 = null;
        } else {
          tmp_3 = new (Dimension())(diff.outlineWidth_1);
        }
        if (!equals(tmp_3, this_1)) {
          tmp_2 = this_1;
        } else {
          tmp_2 = null;
        }
        var tmp_4 = tmp_2;
        var tmp1_safe_receiver = tmp_4 == null ? null : tmp_4.value_1;
        var tmp_5 = tmp1_safe_receiver;
        if ((tmp_5 == null ? null : new (Dimension())(tmp_5)) == null)
          null;
        else {
          var tmp_6 = tmp1_safe_receiver;
          // Inline function 'kotlin.let' call
          var it = (tmp_6 == null ? null : new (Dimension())(tmp_6)).value_1;
          theme$addToCss(this, mediaQuery, backSel, 'outline-width', _Dimension___get_value__impl__urhqzr(it).toString());
          theme$addToCss(this, mediaQuery, backSel, 'outline-style', !equals(it, get_px(0)) ? 'solid' : 'none');
          var tmp0_0 = times_0(it, -1);
          // Inline function 'com.lightningkite.kiteui.models.coerceAtLeast' call
          var other_0 = times_0(theme.padding_1.top_1, -1);
          var tmp$ret$15 = maxOf(new (Dimension())(tmp0_0), new (Dimension())(other_0)).value_1;
          theme$addToCss(this, mediaQuery, backSel, 'outline-offset', _Dimension___get_value__impl__urhqzr(tmp$ret$15).toString());
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_2 = new (Dimension())(theme.elevation_1);
        var tmp_7;
        var tmp_8;
        if (diff == null) {
          tmp_8 = null;
        } else {
          tmp_8 = new (Dimension())(diff.elevation_1);
        }
        if (!equals(tmp_8, this_2)) {
          tmp_7 = this_2;
        } else {
          tmp_7 = null;
        }
        var tmp_9 = tmp_7;
        var tmp2_safe_receiver = tmp_9 == null ? null : tmp_9.value_1;
        var tmp_10 = tmp2_safe_receiver;
        if ((tmp_10 == null ? null : new (Dimension())(tmp_10)) == null)
          null;
        else {
          var tmp_11 = tmp2_safe_receiver;
          // Inline function 'kotlin.let' call
          (tmp_11 == null ? null : new (Dimension())(tmp_11)).value_1;
          theme$addToCss(this, mediaQuery, backSel, 'box-shadow', toBoxShadow(this, theme.elevation_1));
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_3 = new (Dimension())(theme.gap_1);
        var tmp_12;
        var tmp_13;
        if (diff == null) {
          tmp_13 = null;
        } else {
          tmp_13 = new (Dimension())(diff.gap_1);
        }
        if (!equals(tmp_13, this_3)) {
          tmp_12 = this_3;
        } else {
          tmp_12 = null;
        }
        var tmp_14 = tmp_12;
        var tmp3_safe_receiver = tmp_14 == null ? null : tmp_14.value_1;
        var tmp_15 = tmp3_safe_receiver;
        if ((tmp_15 == null ? null : new (Dimension())(tmp_15)) == null)
          null;
        else {
          var tmp_16 = tmp3_safe_receiver;
          // Inline function 'kotlin.let' call
          var it_0 = (tmp_16 == null ? null : new (Dimension())(tmp_16)).value_1;
          theme$addToCss(this, mediaQuery, directSel, '--spacing', _Dimension___get_value__impl__urhqzr(it_0).toString());
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_4 = theme.padding_1;
        var tmp_17;
        var tmp_18;
        if (diff == null) {
          tmp_18 = null;
        } else {
          tmp_18 = diff.padding_1;
        }
        if (!equals(tmp_18, this_4)) {
          tmp_17 = this_4;
        } else {
          tmp_17 = null;
        }
        var tmp4_safe_receiver = tmp_17;
        if (tmp4_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          theme$addToCss(this, mediaQuery, directSel, '--padding', this.css_7z2xgl_k$(tmp4_safe_receiver));
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_5 = new (Dimension())(theme.font_1.size_1);
        var tmp_19;
        var tmp_20;
        if (diff == null) {
          tmp_20 = null;
        } else {
          tmp_20 = new (Dimension())(diff.font_1.size_1);
        }
        if (!equals(tmp_20, this_5)) {
          tmp_19 = this_5;
        } else {
          tmp_19 = null;
        }
        var tmp_21 = tmp_19;
        var tmp5_safe_receiver = tmp_21 == null ? null : tmp_21.value_1;
        var tmp_22 = tmp5_safe_receiver;
        if ((tmp_22 == null ? null : new (Dimension())(tmp_22)) == null)
          null;
        else {
          var tmp_23 = tmp5_safe_receiver;
          // Inline function 'kotlin.let' call
          var it_1 = (tmp_23 == null ? null : new (Dimension())(tmp_23)).value_1;
          theme$addToCss(this, mediaQuery, directSel, 'font-size', _Dimension___get_value__impl__urhqzr(it_1).toString());
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_6 = theme.font_1.font_1;
        var tmp_24;
        var tmp_25;
        if (diff == null) {
          tmp_25 = null;
        } else {
          tmp_25 = diff.font_1.font_1;
        }
        if (!equals(tmp_25, this_6)) {
          tmp_24 = this_6;
        } else {
          tmp_24 = null;
        }
        var tmp6_safe_receiver = tmp_24;
        if (tmp6_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.let' call
          var tmp$ret$51 = this.dynamicCss_1.font_p6doqv_k$(tmp6_safe_receiver);
          theme$addToCss(this, mediaQuery, directSel, 'font-family', tmp$ret$51);
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_7 = theme.font_1.weight_1;
        var tmp_26;
        var tmp_27;
        if (diff == null) {
          tmp_27 = null;
        } else {
          tmp_27 = diff.font_1.weight_1;
        }
        if (!equals(tmp_27, this_7)) {
          tmp_26 = this_7;
        } else {
          tmp_26 = null;
        }
        var tmp7_safe_receiver = tmp_26;
        if (tmp7_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          theme$addToCss(this, mediaQuery, directSel, 'font-weight', tmp7_safe_receiver.toString());
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_8 = theme.font_1.italic_1;
        var tmp_28;
        var tmp_29;
        if (diff == null) {
          tmp_29 = null;
        } else {
          tmp_29 = diff.font_1.italic_1;
        }
        if (!equals(tmp_29, this_8)) {
          tmp_28 = this_8;
        } else {
          tmp_28 = null;
        }
        var tmp8_safe_receiver = tmp_28;
        if (tmp8_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.let' call
          var tmp$ret$67 = tmp8_safe_receiver ? 'italic' : 'normal';
          theme$addToCss(this, mediaQuery, directSel, 'font-style', tmp$ret$67);
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_9 = theme.font_1.allCaps_1;
        var tmp_30;
        var tmp_31;
        if (diff == null) {
          tmp_31 = null;
        } else {
          tmp_31 = diff.font_1.allCaps_1;
        }
        if (!equals(tmp_31, this_9)) {
          tmp_30 = this_9;
        } else {
          tmp_30 = null;
        }
        var tmp9_safe_receiver = tmp_30;
        if (tmp9_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.let' call
          var tmp$ret$76 = tmp9_safe_receiver ? 'uppercase' : 'none';
          theme$addToCss(this, mediaQuery, directSel, 'text-transform', tmp$ret$76);
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_10 = theme.font_1.lineSpacingMultiplier_1;
        var tmp_32;
        var tmp_33;
        if (diff == null) {
          tmp_33 = null;
        } else {
          tmp_33 = diff.font_1.lineSpacingMultiplier_1;
        }
        if (!equals(tmp_33, this_10)) {
          tmp_32 = this_10;
        } else {
          tmp_32 = null;
        }
        var tmp10_safe_receiver = tmp_32;
        if (tmp10_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          theme$addToCss(this, mediaQuery, directSel, 'line-height', tmp10_safe_receiver.toString());
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_11 = theme.font_1.strikethrough_1 && theme.font_1.underline_1 ? 'underline line-through' : theme.font_1.strikethrough_1 ? 'line-through' : theme.font_1.underline_1 ? 'underline' : 'none';
        var tmp_34;
        var tmp_35;
        if (diff == null) {
          tmp_35 = null;
        } else {
          tmp_35 = diff.font_1.strikethrough_1 && diff.font_1.underline_1 ? 'underline line-through' : diff.font_1.strikethrough_1 ? 'line-through' : diff.font_1.underline_1 ? 'underline' : 'none';
        }
        if (!equals(tmp_35, this_11)) {
          tmp_34 = this_11;
        } else {
          tmp_34 = null;
        }
        var tmp11_safe_receiver = tmp_34;
        if (tmp11_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          theme$addToCss(this, mediaQuery, directSel, 'text-decoration-line', tmp11_safe_receiver);
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_12 = theme.font_1.lineSpacingMultiplier_1;
        var tmp_36;
        var tmp_37;
        if (diff == null) {
          tmp_37 = null;
        } else {
          tmp_37 = diff.font_1.lineSpacingMultiplier_1;
        }
        if (!equals(tmp_37, this_12)) {
          tmp_36 = this_12;
        } else {
          tmp_36 = null;
        }
        var tmp12_safe_receiver = tmp_36;
        if (tmp12_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          theme$addToCss(this, mediaQuery, directSel, 'line-height', tmp12_safe_receiver.toString());
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_13 = new (Dimension())(theme.font_1.additionalLetterSpacing_1);
        var tmp_38;
        var tmp_39;
        if (diff == null) {
          tmp_39 = null;
        } else {
          tmp_39 = new (Dimension())(diff.font_1.additionalLetterSpacing_1);
        }
        if (!equals(tmp_39, this_13)) {
          tmp_38 = this_13;
        } else {
          tmp_38 = null;
        }
        var tmp_40 = tmp_38;
        var tmp13_safe_receiver = tmp_40 == null ? null : tmp_40.value_1;
        var tmp_41 = tmp13_safe_receiver;
        if ((tmp_41 == null ? null : new (Dimension())(tmp_41)) == null)
          null;
        else {
          var tmp_42 = tmp13_safe_receiver;
          // Inline function 'kotlin.let' call
          var it_2 = (tmp_42 == null ? null : new (Dimension())(tmp_42)).value_1;
          theme$addToCss(this, mediaQuery, directSel, 'letter-spacing', _Dimension___get_value__impl__urhqzr(it_2).toString());
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_14 = theme.outline_1;
        var tmp_43;
        var tmp_44;
        if (diff == null) {
          tmp_44 = null;
        } else {
          tmp_44 = diff.outline_1;
        }
        if (!equals(tmp_44, this_14)) {
          tmp_43 = this_14;
        } else {
          tmp_43 = null;
        }
        var tmp14_safe_receiver = tmp_43;
        if (tmp14_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          theme$addToCss(this, mediaQuery, directSel, 'outline-color', tmp14_safe_receiver.closestColor_akwbqu_k$().toWeb_1tsvdl_k$());
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_15 = new (Duration())(theme.transitionDuration_1);
        var tmp_45;
        var tmp_46;
        if (diff == null) {
          tmp_46 = null;
        } else {
          tmp_46 = new (Duration())(diff.transitionDuration_1);
        }
        if (!equals(tmp_46, this_15)) {
          tmp_45 = this_15;
        } else {
          tmp_45 = null;
        }
        var tmp_47 = tmp_45;
        var tmp15_safe_receiver = tmp_47 == null ? null : tmp_47.rawValue_1;
        var tmp_48 = tmp15_safe_receiver;
        if ((tmp_48 == null ? null : new (Duration())(tmp_48)) == null)
          null;
        else {
          var tmp_49 = tmp15_safe_receiver;
          // Inline function 'kotlin.let' call
          var it_3 = (tmp_49 == null ? null : new (Duration())(tmp_49)).rawValue_1;
          theme$addToCss(this, mediaQuery, directSel, 'transition-duration', toCss(this, it_3));
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_16 = new (Duration())(theme.transitionDuration_1);
        var tmp_50;
        var tmp_51;
        if (diff == null) {
          tmp_51 = null;
        } else {
          tmp_51 = new (Duration())(diff.transitionDuration_1);
        }
        if (!equals(tmp_51, this_16)) {
          tmp_50 = this_16;
        } else {
          tmp_50 = null;
        }
        var tmp_52 = tmp_50;
        var tmp16_safe_receiver = tmp_52 == null ? null : tmp_52.rawValue_1;
        var tmp_53 = tmp16_safe_receiver;
        if ((tmp_53 == null ? null : new (Duration())(tmp_53)) == null)
          null;
        else {
          var tmp_54 = tmp16_safe_receiver;
          // Inline function 'kotlin.let' call
          var it_4 = (tmp_54 == null ? null : new (Duration())(tmp_54)).rawValue_1;
          theme$addToCss(this, mediaQuery, directSel, '--transition-duration', toCss(this, it_4));
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_17 = theme.background_1;
        var tmp_55;
        var tmp_56;
        if (diff == null) {
          tmp_56 = null;
        } else {
          tmp_56 = diff.background_1;
        }
        if (!equals(tmp_56, this_17)) {
          tmp_55 = this_17;
        } else {
          tmp_55 = null;
        }
        var tmp17_safe_receiver = tmp_55;
        if (tmp17_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          theme$addToCss(this, mediaQuery, directSel, '--nearest-background-color', tmp17_safe_receiver.closestColor_akwbqu_k$().toWeb_1tsvdl_k$());
        }
        // Inline function 'kotlin.run' call
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_18 = theme.cornerRadii_1;
        var tmp_57;
        var tmp_58;
        if (diff == null) {
          tmp_58 = null;
        } else {
          tmp_58 = diff.cornerRadii_1;
        }
        if (!equals(tmp_58, this_18)) {
          tmp_57 = this_18;
        } else {
          tmp_57 = null;
        }
        var radiiChanged = tmp_57;
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_19 = theme.cornerShape_1;
        var tmp_59;
        var tmp_60;
        if (diff == null) {
          tmp_60 = null;
        } else {
          tmp_60 = diff.cornerShape_1;
        }
        if (!equals(tmp_60, this_19)) {
          tmp_59 = this_19;
        } else {
          tmp_59 = null;
        }
        var shapeChanged = tmp_59;
        if (!(radiiChanged == null) || !(shapeChanged == null)) {
          var radii = theme.cornerRadii_1;
          if (theme.cornerShape_1.equals(CornerShape_Continuous_getInstance())) {
            theme$addToCss(this, mediaQuery, paddedSel, 'border-radius', toRawCornerRadius(radii, '--corner-shape-scale'));
            theme$addToCss(this, mediaQuery, paddedSel, 'corner-shape', 'squircle');
          } else {
            theme$addToCss(this, mediaQuery, paddedSel, 'border-radius', toRawCornerRadius(radii));
          }
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_20 = new (Dimension())(theme.blurBackground_1);
        var tmp_61;
        var tmp_62;
        if (diff == null) {
          tmp_62 = null;
        } else {
          tmp_62 = new (Dimension())(diff.blurBackground_1);
        }
        if (!equals(tmp_62, this_20)) {
          tmp_61 = this_20;
        } else {
          tmp_61 = null;
        }
        var tmp_63 = tmp_61;
        var tmp18_safe_receiver = tmp_63 == null ? null : tmp_63.value_1;
        var tmp_64 = tmp18_safe_receiver;
        if ((tmp_64 == null ? null : new (Dimension())(tmp_64)) == null)
          null;
        else {
          var tmp_65 = tmp18_safe_receiver;
          // Inline function 'kotlin.let' call
          var it_5 = (tmp_65 == null ? null : new (Dimension())(tmp_65)).value_1;
          if (!_Dimension___get_value__impl__urhqzr(it_5).equals(Companion_getInstance_1().zero_1)) {
            var filterValue = 'blur(' + _Dimension___get_value__impl__urhqzr(it_5).toString() + ')';
            // Inline function 'kotlin.text.isNotEmpty' call
            if (charSequenceLength(filterValue) > 0) {
              theme$addToCss(this, mediaQuery, backSel, 'backdrop-filter', filterValue);
              theme$addToCss(this, mediaQuery, backSel, '-webkit-backdrop-filter', filterValue);
            } else {
              theme$addToCss(this, mediaQuery, backSel, 'backdrop-filter', 'none');
              theme$addToCss(this, mediaQuery, backSel, '-webkit-backdrop-filter', 'none');
            }
          } else {
            theme$addToCss(this, mediaQuery, backSel, 'backdrop-filter', 'none');
            theme$addToCss(this, mediaQuery, backSel, '-webkit-backdrop-filter', 'none');
          }
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_21 = theme.foreground_1;
        var tmp_66;
        var tmp_67;
        if (diff == null) {
          tmp_67 = null;
        } else {
          tmp_67 = diff.foreground_1;
        }
        if (!equals(tmp_67, this_21)) {
          tmp_66 = this_21;
        } else {
          tmp_66 = null;
        }
        var tmp19_safe_receiver = tmp_66;
        if (tmp19_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          theme$addToCss(this, mediaQuery, directSel, 'color-scheme', tmp19_safe_receiver.closestColor_akwbqu_k$().get_perceivedBrightness_8c130z_k$() > 0.5 ? 'dark' : 'light');
          if (tmp19_safe_receiver instanceof Color()) {
            theme$addToCss(this, mediaQuery, directSel, 'color', tmp19_safe_receiver.toWeb_1tsvdl_k$());
          } else {
            if (tmp19_safe_receiver instanceof FadingColor()) {
              theme$addToCss(this, mediaQuery, directSel, 'color', tmp19_safe_receiver.base_1.toWeb_1tsvdl_k$());
            } else {
              if (tmp19_safe_receiver instanceof LinearGradient()) {
                var tmp0_1 = tmp19_safe_receiver.angle_1;
                // Inline function 'com.lightningkite.kiteui.models.Angle.plus' call
                var other_1 = Companion_getInstance_0().quarterTurn_1;
                var tmp$ret$161 = _Angle___init__impl__g23q1m(_Angle___get_turns__impl__atdtw5(tmp0_1) + _Angle___get_turns__impl__atdtw5(other_1));
                theme$addToCss(this, mediaQuery, directSel, 'color', 'linear-gradient(' + _Angle___get_turns__impl__atdtw5(tmp$ret$161) + 'turn, ' + joinGradientStops(this, tmp19_safe_receiver.stops_1) + ')');
                var tmp0_2 = tmp19_safe_receiver.angle_1;
                // Inline function 'com.lightningkite.kiteui.models.Angle.plus' call
                var other_2 = Companion_getInstance_0().quarterTurn_1;
                var tmp$ret$162 = _Angle___init__impl__g23q1m(_Angle___get_turns__impl__atdtw5(tmp0_2) + _Angle___get_turns__impl__atdtw5(other_2));
                theme$addToCss(this, mediaQuery, directSel, 'background', '-webkit-linear-gradient(' + _Angle___get_turns__impl__atdtw5(tmp$ret$162) + 'turn, ' + joinGradientStops(this, tmp19_safe_receiver.stops_1) + ')');
                theme$addToCss(this, mediaQuery, directSel, '-webkit-background-clip', 'text');
                theme$addToCss(this, mediaQuery, directSel, '-webkit-text-fill-color', 'transparent');
              } else {
                if (tmp19_safe_receiver instanceof RadialGradient()) {
                  theme$addToCss(this, mediaQuery, directSel, 'color', 'radial-gradient(circle at center, ' + joinGradientStops(this, tmp19_safe_receiver.stops_1) + ')');
                  theme$addToCss(this, mediaQuery, directSel, 'background', '-webkit-radial-gradient(circle at center, ' + joinGradientStops(this, tmp19_safe_receiver.stops_1) + ')');
                  theme$addToCss(this, mediaQuery, directSel, '-webkit-background-clip', 'text');
                  theme$addToCss(this, mediaQuery, directSel, '-webkit-text-fill-color', 'transparent');
                } else {
                  noWhenBranchMatchedException();
                }
              }
            }
          }
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_22 = theme.get_icon_wont8i_k$();
        var tmp_68;
        var tmp_69;
        if (diff == null) {
          tmp_69 = null;
        } else {
          tmp_69 = diff.get_icon_wont8i_k$();
        }
        if (!equals(tmp_69, this_22)) {
          tmp_68 = this_22;
        } else {
          tmp_68 = null;
        }
        var tmp20_safe_receiver = tmp_68;
        if (tmp20_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          if (tmp20_safe_receiver instanceof Color()) {
            theme$addToCss(this, mediaQuery, directSel, '--icon-color', tmp20_safe_receiver.toWeb_1tsvdl_k$());
          } else {
            if (tmp20_safe_receiver instanceof FadingColor()) {
              theme$addToCss(this, mediaQuery, directSel, '--icon-color', '');
            } else {
              theme$addToCss(this, mediaQuery, directSel, '--icon-color', tmp20_safe_receiver.closestColor_akwbqu_k$().toWeb_1tsvdl_k$());
            }
          }
        }
        // Inline function 'com.lightningkite.kiteui.views.KiteUiCss.diff' call
        // Inline function 'kotlin.takeUnless' call
        var this_23 = theme.get_separator_xuwon8_k$();
        var tmp_70;
        var tmp_71;
        if (diff == null) {
          tmp_71 = null;
        } else {
          tmp_71 = diff.get_separator_xuwon8_k$();
        }
        if (!equals(tmp_71, this_23)) {
          tmp_70 = this_23;
        } else {
          tmp_70 = null;
        }
        var tmp21_safe_receiver = tmp_70;
        if (tmp21_safe_receiver == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          if (tmp21_safe_receiver instanceof Color()) {
            theme$addToCss(this, mediaQuery, directSel, '--separator-color', tmp21_safe_receiver.toWeb_1tsvdl_k$());
          } else {
            if (tmp21_safe_receiver instanceof FadingColor()) {
              theme$addToCss(this, mediaQuery, directSel, '--separator-color', '');
            } else {
              theme$addToCss(this, mediaQuery, directSel, '--separator-color', tmp21_safe_receiver.closestColor_akwbqu_k$().toWeb_1tsvdl_k$());
            }
          }
        }
        if (diff == null || !equals(diff.transform_1, theme.transform_1)) {
          var it_6 = theme.transform_1;
          if (!(it_6 == null)) {
            // Inline function 'kotlin.collections.mutableListOf' call
            var transformParts = ArrayList().new_kotlin_collections_ArrayList_ony0vx_k$();
            if (!(it_6.translationX_1 === 0.0) || !(it_6.translationY_1 === 0.0) || !(it_6.translationZ_1 === 0.0)) {
              transformParts.add_utx5q5_k$('translate3d(' + it_6.translationX_1 + 'px, ' + it_6.translationY_1 + 'px, ' + it_6.translationZ_1 + 'px)');
            }
            if (!(it_6.rotation_1 === 0.0)) {
              transformParts.add_utx5q5_k$('rotate(' + it_6.rotation_1 + 'deg)');
            }
            if (!(it_6.rotationX_1 === 0.0)) {
              transformParts.add_utx5q5_k$('rotateX(' + it_6.rotationX_1 + 'deg)');
            }
            if (!(it_6.rotationY_1 === 0.0)) {
              transformParts.add_utx5q5_k$('rotateY(' + it_6.rotationY_1 + 'deg)');
            }
            if (!(it_6.scaleX_1 === 1.0) || !(it_6.scaleY_1 === 1.0)) {
              transformParts.add_utx5q5_k$('scale(' + it_6.scaleX_1 + ', ' + it_6.scaleY_1 + ')');
            }
            // Inline function 'kotlin.collections.isNotEmpty' call
            if (!transformParts.isEmpty_y1axqb_k$()) {
              theme$addToCss(this, mediaQuery, backSel, 'transform', joinToString(transformParts, ' '));
            }
          } else {
            theme$addToCss(this, mediaQuery, backSel, 'transform', 'none');
          }
        }
        return classes;
      }
      theme$default_1dahcl_k$(theme, diff, asSelectors, includeMaybeTransition, mediaQuery, $super) {
        diff = diff === VOID ? null : diff;
        asSelectors = asSelectors === VOID ? listOf_0(_get_classSelector__lhiabq(this, theme)) : asSelectors;
        includeMaybeTransition = includeMaybeTransition === VOID ? false : includeMaybeTransition;
        mediaQuery = mediaQuery === VOID ? '' : mediaQuery;
        return $super === VOID ? this.theme_e3nnmq_k$(theme, diff, asSelectors, includeMaybeTransition, mediaQuery) : $super.theme_e3nnmq_k$.call(this, theme, diff, asSelectors, includeMaybeTransition, mediaQuery);
      }
      css_7z2xgl_k$(_this__u8e3s4) {
        return _Dimension___get_value__impl__urhqzr(_this__u8e3s4.top_1).toString() + ' ' + _Dimension___get_value__impl__urhqzr(_this__u8e3s4.right_1).toString() + ' ' + _Dimension___get_value__impl__urhqzr(_this__u8e3s4.bottom_1).toString() + ' ' + _Dimension___get_value__impl__urhqzr(_this__u8e3s4.left_1).toString();
      }
      rowCollapsingToColumn_6s7flu_k$(breakpoints) {
        var name = 'rowCollapsingToColumn_' + joinToString(breakpoints, '_', VOID, VOID, VOID, VOID, KiteUiCss$rowCollapsingToColumn$lambda);
        if (this.rowCollapsingToColumnHandled_1.add_utx5q5_k$(name)) {
          this.dynamicCss_1.rule$default_4ip9wm_k$('\n                .' + name + '.rowCollapsing { display: flex }\n            ');
          // Inline function 'kotlin.collections.forEach' call
          var progression = numberRangeToNumber(-1, breakpoints.get_size_woubt6_k$() - 1 | 0);
          var inductionVariable = progression.first_1;
          var last = progression.last_1;
          if (inductionVariable <= last)
            do {
              var element = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var index = element;
              var tmp = getOrNull(breakpoints, index);
              var tmp0_safe_receiver = tmp == null ? null : tmp.value_1;
              var tmp_0;
              var tmp_1 = tmp0_safe_receiver;
              if ((tmp_1 == null ? null : new (Dimension())(tmp_1)) == null) {
                tmp_0 = null;
              } else {
                var tmp_2 = tmp0_safe_receiver;
                // Inline function 'kotlin.let' call
                var it = (tmp_2 == null ? null : new (Dimension())(tmp_2)).value_1;
                tmp_0 = '(min-width: ' + _Dimension___get_value__impl__urhqzr(it).toString() + ')';
              }
              var tmp_3 = tmp_0;
              var tmp_4 = getOrNull(breakpoints, index + 1 | 0);
              var tmp1_safe_receiver = tmp_4 == null ? null : tmp_4.value_1;
              var tmp_5;
              var tmp_6 = tmp1_safe_receiver;
              if ((tmp_6 == null ? null : new (Dimension())(tmp_6)) == null) {
                tmp_5 = null;
              } else {
                var tmp_7 = tmp1_safe_receiver;
                // Inline function 'kotlin.let' call
                var it_0 = (tmp_7 == null ? null : new (Dimension())(tmp_7)).value_1;
                tmp_5 = '(max-width: ' + _Dimension___get_value__impl__urhqzr(it_0).toString() + ')';
              }
              var mediaQuery = joinToString(listOfNotNull([tmp_3, tmp_5]), ' and ');
              if (((index + 2 | 0) % 2 | 0) === 1) {
                this.dynamicCss_1.rule$default_4ip9wm_k$(trimIndent('\n                    @media ' + mediaQuery + ' {\n                        .' + name + '.rowCollapsing {\n                            flex-direction: column;\n                        }\n                        .' + name + '.rowCollapsing > * {\n                            flex-grow: 0 !important;\n                            flex-shrink: 0 !important;\n                            flex-basis: auto !important;\n                        }\n                        .' + name + '.rowCollapsing > .hStart {\n                            align-self: start;\n                        }\n                        .' + name + '.rowCollapsing > .hCenter {\n                            align-self: center;\n                        }\n                        .' + name + '.rowCollapsing > .hStretch {\n                            align-self: stretch;\n                        }\n                        .' + name + '.rowCollapsing > .hEnd {\n                            align-self: end;\n                        }\n                    }\n                '));
              } else {
                this.dynamicCss_1.rule$default_4ip9wm_k$(trimIndent('\n                    @media ' + mediaQuery + ' {\n                        .' + name + '.rowCollapsing {\n                            flex-direction: row;\n                        }\n                        .' + name + '.rowCollapsing > .vStart {\n                            align-self: start;\n                        }\n                        .' + name + '.rowCollapsing > .vCenter {\n                            align-self: center;\n                        }\n                        .' + name + '.rowCollapsing > .vStretch {\n                            align-self: stretch;\n                        }\n                        .' + name + '.rowCollapsing > .vEnd {\n                            align-self: end;\n                        }\n                    }\n                '));
              }
            }
             while (!(element === last));
        }
        return name;
      }
      querySet_4t8jxf_k$(query) {
        // Inline function 'kotlin.collections.getOrPut' call
        var this_0 = this.querySetHandled_1;
        var value = this_0.get_wei43m_k$(query);
        var tmp;
        if (value == null) {
          // Inline function 'kotlin.text.filter' call
          var tmp0 = render(this, query);
          // Inline function 'kotlin.text.filterTo' call
          var destination = StringBuilder().new_kotlin_text_StringBuilder_u46mrb_k$();
          var inductionVariable = 0;
          var last = charSequenceLength(tmp0);
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var element = charSequenceGet(tmp0, index);
              if (isLetterOrDigit(element)) {
                destination.append_58al37_k$(element);
              }
            }
             while (inductionVariable < last);
          var name = 'querySet_' + destination.toString();
          this.dynamicCss_1.rule$default_4ip9wm_k$('@media not all and ' + render(this, query) + ' { .' + name + ' { display: none !important } }');
          var answer = name;
          this_0.put_4fpzoq_k$(query, answer);
          tmp = answer;
        } else {
          tmp = value;
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'KiteUiCss');
    KiteUiCssClass = $;
  }
  return KiteUiCssClass;
}
//region block: exports
export {
  KiteUiCss as KiteUiCsshhimfofutzw8,
};
//endregion

//# sourceMappingURL=KiteUiCss.mjs.map
